import { USER } from "../../pool";
import axiom from "../../utils/axiom";


export const createApiFromUrl = (details) =>
    axiom.post(USER.base + USER.paths.loginUser, details);
